import { IDatasetBrief } from '../../types/metadata';
import { ISearchDataSetProps, IResultItem } from '../../types/api';
import { obj2parameter } from '../../utils/obj2parameter';

import { axiosInstance } from '../Api';

export default class Search {
  endPoint = 'Search';

  async dataSetBriefs(props: ISearchDataSetProps) {
    const { keyword, datatype, category, location, includeGlobal, vas } = props;
    const parameterObj = {
      keyword: keyword || '',
      datatype: datatype || 'Any',
      category: category || 'Any',
      location: location || 'Any',
      includeGlobal,
      vas: vas || 'metocean',
    };
    const parameters = obj2parameter(parameterObj);
    const IsFWE = vas === 'fwe'
    try {
      const r = await axiosInstance.get<IResultItem<IDatasetBrief[]>>(
        `/${this.endPoint}/SearchDataSet?${parameters}`
      );
      if (r && r.data && r.data.Items) {
        return r.data.Items.map((fweBrief: IDatasetBrief) => {return {...fweBrief, IsFWE}});
      } else {
        return [];
      }
    } catch(error) {
      console.error('Error in dataSetBriefs:', error);
    }
  }
}
